import Modal from './Modal'

export default {
  name: 'modal',
  configure: function(config) {
    config.addComponent('modal', Modal)
  }
}
